import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { parseUrl } from "query-string";
import { checkIfSingleSignOn } from "../../sso-utils";
import { SvgHandler } from "../../../../svg-handler/svg-handler";
import googleIcon from "../../../../../../assets/icons/google.svg";
import facebookIcon from "../../../../../components/basic/social-follow/social-components/circular-color/svg/facebook-circle-color.svg";
import linkedinIcon from "../../../../../components/basic/social-follow/social-components/square/svg/linkedin-square.svg";
import get from "lodash/get";
import { withGoogleLogin, withFacebookLogin, withLinkedinLogin } from "@quintype/bridgekeeper-js";
import "./social-login.module.css";
import { CONTINUE_WITH_FACEBOOK, CONTINUE_WITH_GOOGLE, CONTINUE_WITH_LINKEDIN } from "../../../../../constants";

const getOauthAuthorizeUrl = (bridgeKeeperClientId, currentPath) => {
  const params = parseUrl(currentPath);
  const callbackUrl =
    get(params, ["query", "callback_uri"], global?.localStorage?.getItem("loginRedirectUrl")) || window?.location.href;
  const redirectUrl = get(params, ["query", "redirect_uri"], `${window?.location.origin}/api/auth/v1/oauth/token`);
  return `${
    window.location.origin
  }/api/auth/v1/oauth/authorize?redirect_uri=${redirectUrl}&client_id=${bridgeKeeperClientId}&callback_uri=${encodeURIComponent(
    callbackUrl
  )}&response_type=code`;
};

const SocialLoginButton = ({ data, logo, clazzName, providerLogin, label }) => {
  const [loginPath, setLoginPath] = useState("");

  useEffect(() => {
    const { serverSideLoginPath } = providerLogin(data);
    setLoginPath(serverSideLoginPath);
    return;
  }, [providerLogin, data]);

  return (
    <a href={loginPath} target="_self" styleName="icon-wrapper">
      <SvgHandler xlinkHref={logo} clazzName={clazzName} width="20" height="20" />
      <span styleName="text-wrapper">{label}</span>
    </a>
  );
};

const getSocialProvidersData = ({ googleLoginLabel = "", facebookLoginLabel = "", linkedInLoginLabel = "" }) => {
  return [
    {
      provider: "google",
      logo: googleIcon,
      clazzName: "google",
      label: googleLoginLabel || CONTINUE_WITH_GOOGLE,
      providerLogin: withGoogleLogin,
    },
    {
      provider: "facebook",
      logo: facebookIcon,
      clazzName: "facebook",
      label: facebookLoginLabel || CONTINUE_WITH_FACEBOOK,
      providerLogin: withFacebookLogin,
    },
    {
      provider: "linkedin",
      logo: linkedinIcon,
      clazzName: "linkedin",
      label: linkedInLoginLabel || CONTINUE_WITH_LINKEDIN,
      providerLogin: withLinkedinLogin,
    },
  ];
};

export const SocialLogin = ({ mode }) => {
  const [urlToBeRedirected, setRedirectUrl] = useState("/");
  const { general = {}, login = {} } = useSelector((state) => get(state, ["qt", "config", "pagebuilder-config"], {}));
  const { sso = {} } = general;
  const loginConfig = get(login, ["sign-in", "rows", 0, "config"], {});
  const currentPath = useSelector((state) => get(state, ["qt", "currentPath"], ""));
  const { bridgeKeeperClientId = "" } = sso;

  useEffect(() => {
    const oauthAuthorizeUrl = getOauthAuthorizeUrl(bridgeKeeperClientId, currentPath);
    setRedirectUrl(checkIfSingleSignOn(sso) ? oauthAuthorizeUrl : global?.localStorage?.getItem("loginRedirectUrl"));
  }, [sso]);

  const data = {
    scope: "email",
    emailMandatory: true,
    redirectUrl: encodeURIComponent(urlToBeRedirected),
  };

  const socialProviders = getSocialProvidersData(loginConfig);

  return (
    <div styleName={mode} className="socialIconWrapper">
      {socialProviders.map((config) => (
        <SocialLoginButton key={config?.provider} data={data} {...config} />
      ))}
    </div>
  );
};
